import { Directive, Input, AfterViewInit } from '@angular/core';
import { ResourcesService } from '@m4u-angular/core/framework/resources.service';
import { DxTextBoxComponent, DxSelectBoxComponent, DxNumberBoxComponent, DxCheckBoxComponent, DxRadioGroupComponent, DxDateBoxComponent, DxTextAreaComponent } from 'devextreme-angular';
import { DxiColumnComponent } from 'devextreme-angular/ui/nested';
import Validator from "devextreme/ui/validator";

export class M4UStandardDirective implements AfterViewInit {
    constructor(private c: any,
        private rule: string,
        private IsColumn: boolean) { }

    private m_bInitComplete: boolean;

    _Enabled: boolean = true;
    @Input() set Enabled(value: boolean) {

        //Prevent double execution
        if (this.Enabled == value) return;
        this._Enabled = value;


        //Run only if changing after initialization
        if (this.m_bInitComplete) this.Init();
    }

    @Input() RequiredMessage: string;

    ngAfterViewInit() {
        this.Init()
        this.m_bInitComplete = true;
    }

    private Init() {
        if (this.IsColumn) this.InitColumnRules(); else this.InitNormalRules();
    }

    InitNormalRules() {
        let oElementInstance = this.c.instance;
        let validatorInstance = Validator.getInstance(oElementInstance.element()) as Validator;
        if (!validatorInstance) validatorInstance = new Validator(oElementInstance.element(), {});

        // var overlay = validatorInstance.element().find(".dx-invalid-message.dx-overlay");
        // overlay.dxValidationMessage("instance" ).option( "position", {
        //            my: 'bottom right',
        //            at: "top right",
        // });

        let rules = validatorInstance.option("validationRules") as any[];

        //Add the rule, or filter it out
        if (this._Enabled) {
            rules.push({
                type: this.rule,
                // message: this.RequiredMessage || (this.resourcesService.RC('errorRequiredMessage'))
            });
        }
        else {
            rules = rules.filter(x => x.type != this.rule);
        }

        //Set
        validatorInstance.option("validationRules", rules);
    }

    InitColumnRules() {
        let rules = this.c._getOption("validationRules");
        if (rules == undefined) rules = [];

        //Add the rule, or filter it out
        if (this._Enabled) {
            rules.push({ type: this.rule });
        }
        else {
            rules = rules.filter(x => x.type != this.rule);
        }

        //Set
        this.c._setOption("validationRules", rules);
    }
}


@Directive({ selector: 'dx-text-box[configRequired]' })
export class M4URequiredDirectiveTextBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxTextBoxComponent, resourcesService: ResourcesService) { super(c, "required", false) }
    override ngAfterViewInit() { super.ngAfterViewInit(); }
}

@Directive({ selector: 'dx-number-box[configRequired]' })
export class M4URequiredDirectiveNumberBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxNumberBoxComponent, resourcesService: ResourcesService) { super(c, "required", false) }
    override ngAfterViewInit() { super.ngAfterViewInit(); }
}

@Directive({ selector: 'dx-select-box[configRequired]' })
export class M4URequiredDirectiveSelectBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxSelectBoxComponent, resourcesService: ResourcesService) { super(c, "required", false) }
    override ngAfterViewInit() { super.ngAfterViewInit(); }
}

@Directive({ selector: 'dx-check-box[configRequired]' })
export class M4URequiredDirectiveCheckBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxCheckBoxComponent, resourcesService: ResourcesService) { super(c, "required", false) }
    override ngAfterViewInit() { super.ngAfterViewInit(); }
}


@Directive({ selector: 'dx-radio-group[configRequired]' })
export class M4URequiredDirectiveRadioGroup extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxRadioGroupComponent, resourcesService: ResourcesService) { super(c, "required", false) }
    override ngAfterViewInit() { super.ngAfterViewInit(); }
}


@Directive({ selector: 'dx-date-box[configRequired]' })
export class M4URequiredDirectiveDateBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxDateBoxComponent, resourcesService: ResourcesService) { super(c, "required", false) }
    override ngAfterViewInit() { super.ngAfterViewInit(); }
}

@Directive({ selector: 'dxi-column[configRequired]' })
export class M4URequiredDirectiveColumn extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxiColumnComponent, resourcesService: ResourcesService) { super(c, "required", true) }
    override ngAfterViewInit() { super.ngAfterViewInit(); }
}

@Directive({ selector: 'dx-text-area[configRequired]' })
export class M4URequiredDirectiveTextArea extends M4UStandardDirective implements AfterViewInit {
    constructor(c: DxTextAreaComponent, resourcesService: ResourcesService) { super(c, "required", false) }
    override ngAfterViewInit() { super.ngAfterViewInit(); }
}
